import axios from '../../api/vue-axios/axios'
import store from '../../store'
import stringHelper from '../../helpers/stringHelper.js'

const state = {
  script: {}
}

const mutations = {
  setScript (state, script) {
    state.script = script
  }
}

const getters = {
  script (state) {
    return state.script
  }
}

const actions = {
  setScript (context, script_id) {
    return axios.get('users/' + store.getters.currentUser.id + '/scripts/' + script_id).then((response) => {
      context.commit('setScript', stringHelper.camelizeObject(response.data.script))
    })
  },
  updateScript (context, script) {
    context.commit('setScript', script)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/script.js